export default __webpack_public_path__ + "static/media/blob-21.f428faf5.svg";